/**
 * Nine-bar equaliser wave loader
 * Bars pulse in height and shift down in a staggered wave.
 * Colors follow --ka-widget-color-primary (space-separated RGB).
 */

const BARS = [
  { left: 0, delay: 0 },
  { left: 20, delay: 0.15 },
  { left: 40, delay: 0.3 },
  { left: 60, delay: 0.45 },
  { left: 80, delay: 0.6 },
  { left: 100, delay: 0.75 },
  { left: 120, delay: 0.9 },
  { left: 140, delay: 1.05 },
  { left: 160, delay: 1.2 },
] as const;

const BAR_STYLES = `
  .ka-l3-bars {
    position: relative;
    width: 170px;
    height: 100px;
  }
  .ka-l3-bar {
    position: absolute;
    width: 10px;
    height: 30px;
    background-color: rgb(var(--ka-widget-color-primary, 57 0 140));
    border-radius: 5px;
    animation: ka-l3-bar-anim 3s ease-in-out infinite;
  }
  @keyframes ka-l3-bar-anim {
    0%   { height: 30px; transform: translate(0, 0); }
    50%  { height: 70px; transform: translate(0, 35px); }
    100% { height: 30px; transform: translate(0, 0); }
  }
`;

export function LoadingSpinner() {
  return (
    <>
      <style>{BAR_STYLES}</style>
      <div className="ka-l3-bars">
        {BARS.map(({ left, delay }) => (
          <div
            key={left}
            className="ka-l3-bar"
            style={{ left, animationDelay: `${delay}s` }}
          />
        ))}
      </div>
    </>
  );
}
